import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMenuContext } from "../contexts/MenuContext";

const TitleBar = () => {
        const menuContent = useMenuContext();
        const location = useLocation();
        const [sectionPath, pagePath] = location.pathname.split("/").slice(1);
        const [pageSection, setPageSection] = useState("");
        const [pageTitle, setPageTitle] = useState("");
        const [isNew, setIsNew] = useState(false);

        useEffect(() => {
                menuContent.forEach((section) => {
                        if (section.route === `/${sectionPath}`) {
                                setPageSection(section.title);
                        }

                        section.items.forEach((item) => {
                                if (item.route === `/${pagePath}`) {
                                        setPageTitle(item.name);
                                        setIsNew(item.new);
                                }
                        });
                });
        });



        return (
                <div className="section-path">
                        <div className="path-section menu-section-title">{pageSection}</div>
                        {/* <img className="path-icon" src="../icons/chevron-right-blue.svg" /> */}
                        <div className="path-name">
                                {pageTitle}
                                {isNew && <div className="new-badge">NEW</div>}
                        </div>
                </div>
        );
}

export default TitleBar;